import { application } from '@core/controllers/app';

application.register('bundle-manager--bundle-form',
  require('./bundle_manager/bundle_form_controller').default);

application.register('bundle-manager--comment-form',
  require('./bundle_manager/comment_form_controller').default);
